"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_classValue = require("marko/dist/runtime/helpers/class-value"),
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/components/StarRating/index.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    marko_forRange = require("marko/dist/runtime/helpers/for-range"),
    marko_styleValue = require("marko/dist/runtime/helpers/style-value"),
    marko_attrs0 = {
        style: "color:inherit"
      };

function render(input, out, __component, component, state) {
  var data = input;

  input.score = input.percentage ? Math.round( ( input.percentage * 5 ) / 100 ) : input.score

  const colorClass = input.color ? input.color +'-text text-darken-3' : 'yellow-text text-darken-3'

  out.be("ul", {
      "class": marko_classValue(marko_classValue([
        "list-inline m-0",
        input.score ? colorClass : "grey-text"
      ]))
    }, "0", component, null, 1);

  var $for$0 = 0;

  marko_forRange(1, 5, 1, function(index) {
    var $keyScope$0 = "[" + (($for$0++) + "]");

    out.e("li", marko_attrs0, "1" + $keyScope$0, component, 1)
      .e("i", {
          "class": marko_classValue("bx " + (input.score >= index ? "bxs-star" : Math.round(input.score) == index ? "bxs-star-half" : "bx-star")),
          style: marko_styleValue("color:inherit;" + (input.size ? ("font-size:" + input.size) + "px" : ""))
        }, "2" + $keyScope$0, component, 0, 1);
  });

  out.ee();
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
